
<div>
  <label>{{filterElement.label_title || "Unconfigured Filter"}}</label>
  <p><a :href="path" class="btn-link">Configure Filter</a></p>
</div>
